<span class="identificacao-pessoa">
    <!-- Sem `rotuloRetrato` o retrato é enfeite (`aria-hidden`): quem nomeia a pessoa é o texto ao
         lado, e ele existe mesmo sem foto para o nome não dançar entre as linhas. Com rótulo, o
         rosto é de OUTRA pessoa que não a nomeada ao lado, e aí precisa se anunciar. -->
    @if (foto(); as retrato) {
        <img [src]="retrato" [alt]="rotuloRetrato()" class="identificacao-pessoa-retrato" [attr.aria-hidden]="rotuloRetrato() ? null : 'true'" />
    } @else if (iniciais(); as letras) {
        <span class="identificacao-pessoa-retrato identificacao-pessoa-retrato--iniciais" [attr.aria-label]="rotuloRetrato() || null" [attr.aria-hidden]="rotuloRetrato() ? null : 'true'">{{ letras }}</span>
    } @else {
        <span class="identificacao-pessoa-retrato identificacao-pessoa-retrato--iniciais" [attr.aria-label]="rotuloRetrato() || null" [attr.aria-hidden]="rotuloRetrato() ? null : 'true'"><i class="pi pi-user"></i></span>
    }

    <span class="identificacao-pessoa-textos">
        @if (protocolo()) {
            <span class="identificacao-pessoa-badge">#{{ protocolo() }}</span>
        }
        <strong class="identificacao-pessoa-nome" [title]="nome()">{{ nome() }}</strong>
        <!-- Vazia some, sem placeholder: solicitação sem CRM legível é caso real, e um "não
             informado" repetido em toda linha seria ruído em vez de informação. -->
        @if (inscricao()) {
            <span class="identificacao-pessoa-inscricao">{{ inscricao() }}</span>
        }
    </span>
</span>
